<template>
  <el-dropdown trigger="click" hide-on-click>
    <div
      class="data-table-list-status-button pointer"
      :class="
        status === ''
          ? 'info'
          : status === null
          ? 'info'
          : status === '未設定'
          ? 'info'
          : status == '承諾'
          ? 'primary'
          : status == '確認中'
          ? 'success'
          : status == '完了'
          ? 'warning'
          : status == 'NG'
          ? 'danger'
          : ''
      "
      style="margin-left:10px; width:80px;">
      <div class="status-button">
        <i class="el-icon-minus" v-if="status == ''"></i>
        <i class="el-icon-minus" v-if="status == null"></i>
        <i class="el-icon-minus" v-if="status == '未設定'"></i>
        <span v-if="status == '確認中'">!</span>
        <i class="el-icon-right" v-if="status == '承諾'"></i>
        <i class="el-icon-check" v-if="status == '完了'"></i>
        <i class="el-icon-close" v-if="status == 'NG'"></i>
      </div>
      {{ status == null || status == "" ? "未設定" : status }}
      <font-awesome-icon icon="caret-down" style="margin-left:5px; color:#aaa" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item in items" :key="item.name" @click.native="addStatus(item.name)">
        <i :class="'el-icon-' + item.icon" style="margin-right:5px"></i>
        {{ item.name }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
const root = process.env.VUE_APP_API;
const addStatusAPI = root + "/api/list/add_status";

export default {
  name: "status",
  props: ["list_id", "sns_type", "status", "id", "index", "reffrer"],
  data() {
    return {
      items: [
        { name: "未設定", icon: "minus" },
        { name: "承諾", icon: "right" },
        { name: "確認中", icon: "warning-outline" },
        { name: "完了", icon: "check" },
        { name: "NG", icon: "close" },
      ],
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.list.edit;
    },
  },
  methods: {
    addStatus(value) {
      if (this.permission) {
        if (this.reffrer == "editBulk") {
          this.$emit("addStatus", value);
        } else {
          var params = new URLSearchParams();
          params.append("list_id", this.list_id);
          params.append("influencer", this.id);
          params.append("sns_type", this.sns_type);
          params.append("status", value);
          params.append("token", this.token);
          this.axios.post(addStatusAPI, params).then(() => {
            this.$emit("syncStatus", this.index, value, this.list_id);
          });
        }
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
  },
};
</script>

<style></style>
